module.exports = __webpack_public_path__ + "img/78b6c3594436757ce34b10da5ced089b.png";